export default __webpack_public_path__ + "static/media/raisin.19e8e32a.jpg";